<script setup lang="ts">
import { formatCurrency } from '~/utils/formatters'
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'

interface Props {
  median: number
  baseAverage: number
  marketText: string
}

defineProps<Props>()

const { activePeriod, displayPeriods } = useGlobalSalaryPeriod()
</script>

<template>
  <div class="space-y-8">
    <div class="space-y-2">
      <div class="flex items-center">
        <div class="text-4xl font-bold text-primary-600">
          {{ formatCurrency(median) }}
        </div>
        <div class="text-gray-500 ml-2">
          / {{ displayPeriods[activePeriod] }}
        </div>
      </div>
    </div>
  </div>
</template>
